module.exports = __webpack_public_path__ + "img/Aaron-01.b55d8976.svg";